import { P, FF } from "../../styles/tokens";
import { SECTION_TABS } from "../../constants/navigation";
import { useNavigation } from "../../contexts/NavigationContext";
import { useFinancial } from "../../contexts/FinancialContext";
import { useUI } from "../../contexts/UIContext";

export default function SecTabs() {
  const { section, setSection } = useNavigation();
  const { alertCount } = useFinancial();
  const { mobile } = useUI();

  return (
    <div role="tablist" style={{ display:"flex", gap:6, overflowX:"auto", paddingBottom:2 }}>
      {SECTION_TABS.map(s=>(
        <button key={s.id} role="tab" aria-selected={section===s.id} onClick={()=>setSection(s.id)}
          style={{ flexShrink:0, padding: mobile?"12px 16px":"10px 18px", minHeight:44, borderRadius:12,
            border: `1.5px solid ${section===s.id ? P.text : P.border}`,
            background: section===s.id ? P.text : P.surface,
            color: section===s.id ? "#fff" : P.textSm,
            cursor:"pointer", fontFamily:FF, fontSize:12,
            fontWeight: section===s.id ? 700 : 500, whiteSpace:"nowrap",
            display:"flex", alignItems:"center", gap:5 }}>
          <span>{s.icon}</span><span>{s.label}</span>
        </button>
      ))}
    </div>
  );
}
